export default __webpack_public_path__ + "static/media/sarovar.488f6b30.svg";